import React, { createContext, useContext, useState, ReactNode } from 'react';
import TimeoutModal from '../components/TimeoutModal';

interface TimeoutContextType {
  showTimeout: (operationName?: string, onRetry?: () => void) => void;
}

const TimeoutContext = createContext<TimeoutContextType | undefined>(undefined);

export const useTimeout = () => {
  const context = useContext(TimeoutContext);
  if (!context) {
    throw new Error('useTimeout must be used within TimeoutProvider');
  }
  return context;
};

interface TimeoutProviderProps {
  children: ReactNode;
}

export const TimeoutProvider: React.FC<TimeoutProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [operationName, setOperationName] = useState<string>('la operación');
  const [retryHandler, setRetryHandler] = useState<(() => void) | undefined>(undefined);

  const showTimeout = (opName?: string, onRetry?: () => void) => {
    setOperationName(opName || 'la operación');
    setRetryHandler(() => onRetry);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setOperationName('la operación');
    setRetryHandler(undefined);
  };

  const handleRetry = () => {
    if (retryHandler) {
      retryHandler();
    }
    handleClose();
  };

  return (
    <TimeoutContext.Provider value={{ showTimeout }}>
      {children}
      <TimeoutModal
        isOpen={showModal}
        onClose={handleClose}
        onRetry={retryHandler ? handleRetry : undefined}
        operationName={operationName}
      />
    </TimeoutContext.Provider>
  );
};
